// Import the edliy_utils
import {
    makeResponsive,
    placeTitle,
    placeImage,
    placeInput,
    placeSlider,
    hoverMe,
    placeRec,
    hiddenPt,
    fixedPt,
    clearInputFields,
    dragMe,
    placeArrow,
    placeGravity,
    placeText,
    placeLine,
    placePoint,
    placeGlider,
    placeRuler,
    placeLeftText,
    placeSliderSwitch
} from '../../../common/edliy_utils-circle';
const Boxes = {
  box1: function () {
	JXG.Options.board.minimizeReflow = 'none';
  JXG.Options.point.showInfoBox=false;
  JXG.Options.point.highlight=false;
  JXG.Options.text.highlight=false;
  JXG.Options.text.fixed=true;
  JXG.Options.curve.highlight=false;
  JXG.Options.text.cssDefaultStyle='fontFamily:Oswald;'
  var brd1 = JXG.JSXGraph.initBoard('jxgbox1',{boundingbox: [0, 40, 40, 0],keepaspectratio: true, axis:true, ticks:true, grid:true, showCopyright:false, showNavigation:false, pan:{enabled:false}, zoom:{enabled:false}});
  makeResponsive(brd1);
  brd1.options.layer['image'] =14;
  brd1.options.layer['chart'] =14;
  brd1.options.layer['line'] =15;
//	brd1.create('text', [6, 11.5, 'Fraction'],{highlight:false, display:'internal', anchorX:'middle', anchorY:'middle', CssStyle:'fontFamily:Oswald;fontWeight:bold',fontSize:function(){return Math.round(32*brd1.canvasWidth/800.)}, fixed:true});
  placeTitle(brd1, 'Arithmetic Progression', '');

  brd1.suspendUpdate();
  //Variables
  var vectorText1 = [];
  var vectorComa = [];
  var vectorCoins1 = [];
  var vectorCoins2 = [];
  var vectorCoins3 = [];


  //Title and subtitle
  //var title1 = brd1.create('text', [14, 18, '<b> Arithmetic Progression <b>'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(28*brd1.canvasWidth/500.)}},);

  //Sliders
  var a0 = brd1.create('slider',[[20,12],[25,12],[0,2,5]], {snapWidth: 1, snapToGrid: false ,face:'circle', size:3, name:'a_0', strokeColor:'black', label:{fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
  var cd = brd1.create('slider',[[20,11],[25,11],[-5,2,5]], {snapWidth: 1, snapToGrid: false ,face:'circle', size:3, name:'d', strokeColor:'black', label:{fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
  var nTerms = brd1.create('slider',[[20,10],[25,10],[1,4,5]], {snapWidth: 1, snapToGrid: false ,face:'circle', size:3, name:'n', strokeColor:'black', label:{fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});

  //Text
  var txt3 = brd1.create('text', [20, 35, 'n^t^h term : a_0 + (n -1)d  ' ],{fixed: true, anchorX: 'middle', anchorY: 'middle',  strokeColor: 'black',  CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(16*brd1.canvasWidth/500.)}},);
  var txt4 = brd1.create('text', [23.5, 7.5, 'Number of Coins:  ' ],{fixed: true, anchorX: 'middle', anchorY: 'middle',  strokeColor: function(){ if(nTerms.Value()*(2*a0.Value() + (nTerms.Value()-1)*cd.Value())/2 > 0){return 'Green'} else{return 'red'}},  CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(16*brd1.canvasWidth/500.)}},);
  var txt5 = brd1.create('text', [17,30, '  S_n = <u> n </u> (a_0 + a_n)'],{fixed: true, anchorX: 'middle', anchorY: 'middle',  strokeColor: function(){ if(nTerms.Value()*(2*a0.Value() + (nTerms.Value()-1)*cd.Value())/2 > 0){return 'Green'} else{return 'red'}},  CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(16*brd1.canvasWidth/500.)}},);
  var txt6 = brd1.create('text', [21.7, 5, '2'],{fixed: true, anchorX: 'middle', anchorY: 'middle',  strokeColor: function(){ if(nTerms.Value()*(2*a0.Value() + (nTerms.Value()-1)*cd.Value())/2 > 0){return 'Green'} else{return 'red'}},  CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(16*brd1.canvasWidth/500.)}},);
  var txt7 = brd1.create('text', [20, 30, function() {return '=  ' +  nTerms.Value()*(2*a0.Value() + (nTerms.Value()-1)*cd.Value())/2 }],{fixed: true, anchorX: 'middle', anchorY: 'middle',  strokeColor: function(){ if(nTerms.Value()*(2*a0.Value() + (nTerms.Value()-1)*cd.Value())/2 > 0){return 'Green'} else{return 'red'}},  CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(16*brd1.canvasWidth/500.)}},);

  //Functions
  function writeProgression(){

      for (var i=0; i<vectorText1.length; i = i+1){
          brd1.removeObject(vectorText1[i]);
      }
      vectorText1 = [];

      for (var i=0; i<vectorComa.length; i = i+1){
          brd1.removeObject(vectorComa[i]);
      }
      vectorComa = [];

      for (var i=1 ; i <= nTerms.Value() ; i = i +1 ){

          var sequence = brd1.create('text', [11 - nTerms.Value()/2 + i*1.5, 14, a0.Value() + cd.Value()*(i - 1) ],{fixed: true, anchorX: 'middle', anchorY: 'middle', strokeColor: 'black', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd1.canvasWidth/500.)}},);
          vectorText1.push(sequence);

          var txtComa = brd1.create('text', [11.5 - nTerms.Value()/2 + i*1.5, 14, ',' ],{fixed: true, anchorX: 'middle', anchorY: 'middle', strokeColor: 'black',CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd1.canvasWidth/500.)}},);
          vectorComa.push(txtComa);
      }

      brd1.removeObject(vectorComa[nTerms.Value()-1]);

      var txt1 = brd1.create('text', [function(){ return 12 - nTerms.Value()/2 }, 14, '{'],{fixed: true, anchorX: 'middle', anchorY: 'middle', strokeColor: 'black', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd1.canvasWidth/500.)}},);
      var txt2 = brd1.create('text', [function(){ return 12 + nTerms.Value() }, 14, '}'],{fixed: true, anchorX: 'middle', anchorY: 'middle', strokeColor: 'black', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd1.canvasWidth/500.)}},);
  }

  function drawCoins(){

      for (var i=0; i<vectorCoins1.length; i = i+1){
          brd1.removeObject(vectorCoins1[i]);
      }
      vectorCoins1 = [];

      for (var i=0; i<vectorCoins2.length; i = i+1){
          brd1.removeObject(vectorCoins2[i]);
      }
      vectorCoins2 = [];

      for (var i=0; i<vectorCoins3.length; i = i+1){
          brd1.removeObject(vectorCoins3[i]);
      }
      vectorCoins3 = [];


      for ( var x=1; x<= nTerms.Value(); x = x+1){

          if(a0.Value() + cd.Value()*(x - 1) >=0){

              for ( var y=1; y<= a0.Value() + cd.Value()*(x - 1); y = y+1){

                  var coins1 = brd1.create('image', ['/assets/dollar.svg', [x*3, y*1.3], [1.2,1.2]], {visible: true, fixed: true});
                  vectorCoins1.push(coins1);
              }
          }
          else{

              for ( var y=-1; y>= a0.Value() + cd.Value()*(x - 1); y = y-1){

                  var coins3 = brd1.create('image', ['/assets/dollar.svg', [x*3, y*1.3], [1.2 ,1.2]], {visible: true, fixed: true});
                  vectorCoins3.push(coins3);

              }
          }
      }

      for ( var x=2; x<= nTerms.Value(); x = x+1){
          for ( var y=1; y<=  cd.Value(); y = y+1){

              var coins2 = brd1.create('image', ['/assets/dollar.svg', [x*3, (y + a0.Value() + cd.Value()*(x - 1) - cd.Value() )*1.3], [1.2,1.2]], {visible: true, fixed: true});
              vectorCoins2.push(coins2);
          }
      }

  }

  function drawSum(){

      for (var i=0; i<vectorPoints2.length; i = i+1){
          brd1.removeObject(vectorPoints2[i]);
      }
      vectorPoints2 = [];

      for (var i=1 ; i <= nTerms.Value() ; i = i +1 ){

          var points2 = brd1.create('point', [i-1, i*(2*a0.Value() + (i-1)*cd.Value())/2 ],{face:'o' , name: i ,  strokeColor: 'green', fillColor: 'green', size:2,withLabel:false, fixed:true, visible:true, label:{fontSize:function(){return 18*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});;
          vectorPoints2.push(points2);


      }
  }

  a0.on('up', function(){writeProgression(); drawCoins();  });
  cd.on('up', function(){writeProgression(); drawCoins();  });
  nTerms.on('up', function(){writeProgression(); drawCoins();  });

  brd1.unsuspendUpdate();

},
}
export default Boxes;
